<div class="text-truncate bordered">
  @if (date != null) {
    {{ text | date: format }}
  }
</div>